/* global BackboneEx */
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';

function getModuleUrl(moduleName) {
  return Wahanda.Url.getFullUrl(moduleName).split('#')[0];
}

App.Views.PhotoshootConfirmation = BackboneEx.View.Main.extend({
  initialize() {},

  render() {
    App.headerView.setModule('photoshoot-confirmation');
    const node = this.$('#photoshoot-confirmation-section').get(0);
    if (node) {
      ReactDOM.render(
        <Reconnect
          name="PhotoshootOrderPage"
          props={{
            step: 'confirmation',
            reviewUrl: getModuleUrl('photoshoot'),
            confirmationUrl: getModuleUrl('photoshoot-confirmation'),
            dashboardUrl: getModuleUrl('dashboard'),
          }}
        />,
        node,
      );
    }
  },
});
